import ApiService from "@/api.service";
import API from "@/API";


export const GET_LIST_PAYMENTS = "GET_LIST_PAYMENTS";
export const GET_DETAIL_PAYMENTS = "GET_DETAIL_PAYMENTS";
export const SET_LIST_PAYMENTS = "SET_LIST_PAYMENTS";
export const SET_DETAIL_PAYMENTS = "SET_DETAIL_PAYMENTS";

export const GET_LIST_PAYMENTS_BY_SEARCH = "GET_LIST_PAYMENTS_BY_SEARCH";
export const SET_LIST_PAYMENTS_BY_SEARCH = "SET_LIST_PAYMENTS_BY_SEARCH";

export const GET_LIST_PRICING = "/admin/pricing";
export const SET_LIST_PRICING = "SET_LIST_PRICING";

const state = {
    payments: [],
    paymentDetail: {},
    paymentsBySearch: [],
    pricing:[]
};

const getters = {
    payments(state) {
        return state.payments;
    },
    paymentDetail(state) {
        return state.paymentDetail;
    },

    paymentsBySearch(state) {
        return state.paymentsBySearch;
    },
    pricing(state) {
        return state.pricing;
    },

};

const actions = {
    [GET_LIST_PAYMENTS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_PAYMENTS}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PAYMENTS, data);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_PAYMENTS](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PAYMENTS}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PAYMENTS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PAYMENTS_BY_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_LIST_PAYMENTS_BY_SEARCH}`, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PAYMENTS_BY_SEARCH, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PRICING](context) {
        return new Promise(resolve => {
            ApiService.query(`${GET_LIST_PRICING}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PRICING, data);
                }
                resolve(data);
            });
        });
    },

};

const mutations = {
    [SET_LIST_PAYMENTS](state, data) {
        state.payments = data.data;

    },
    [SET_DETAIL_PAYMENTS](state, data) {
        state.paymentDetail = data.data;
    },
    [SET_LIST_PAYMENTS_BY_SEARCH](state, data) {
        state.paymentsBySearch = data.data;
    },
    [SET_LIST_PRICING](state, data) {
        state.pricing = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};